import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaClock, FaCalendarAlt } from "react-icons/fa";

import {
  FaList,
  FaExchangeAlt,
  FaSyncAlt,
} from "react-icons/fa";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";

const getImageSrc = (image) => {
  if (!image) return "/images/cleaning.jpg";
  if (image.startsWith("http")) return image;
  return `${API_BASE_URL}${image}`;
};

function CleaningListings() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
const [filters, setFilters] = useState({
  service: "Cleaning",
  mode: "listings",
  state: "",
  postcode: "",
});


const ROUTES = {
  Cleaning: {
    listings: "/cleaning/listings",
    swaps: "/cleaning/swaps",
    rounds: "/cleaning/rounds",
  },
"Lawn Mowing": {
  listings: "/listings",
  swaps: "/swaps",
  rounds: "/lawn-mowing/rounds",
},
  "Pool Care": {
    listings: "/poolcare/listings",
    swaps: "/poolcare/swaps",
  },
};






  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 768;


 
/* ===========================
   OPTIONS (MATCH LISTINGS)
=========================== */
const options = {
  state: ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"],
};

/* ===========================
   FETCH + SEARCH (URL SYNC)
=========================== */
useEffect(() => {
  const params = new URLSearchParams(location.search);
  const search = params.get("search") || "";

  const query = new URLSearchParams();

  if (search) query.append("search", search);
  if (filters.state) query.append("state", filters.state);
  if (filters.postcode) query.append("postcode", filters.postcode);

  async function loadListings() {
    try {
      const res = await fetch(
        `${API_BASE_URL}/api/cleaning/listings/list?${query.toString()}`
      );
      if (!res.ok) throw new Error(`Server ${res.status}`);

      const json = await res.json();

      // ✅ correct array source
      const visible = (json.listings || []).filter(
  (l) =>
    l.listing_status === "active" ||
    l.listing_status === "locked"
);


      setListings(visible);
    } catch (err) {
      console.error("❌ Failed to load cleaning listings:", err);
      setListings([]);
    } finally {
      setLoading(false);
    }
  }

  loadListings();
}, [
  location.search,
  filters.state,
  filters.postcode,
]);


/* ===========================
   FILTER LOGIC (LISTINGS STYLE)
=========================== */
const filteredListings = listings.filter((listing) => {
  const matchState =
    !filters.state || listing.state === filters.state;

  const matchPostcode =
    !filters.postcode ||
    listing.postcode?.includes(filters.postcode);

  return matchState && matchPostcode;
});

if (loading) {
  return <p style={{ padding: "20px" }}>Loading listings…</p>;
}


return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    overflow: "hidden",   // ✅ THIS FIXES THE GAP
    backgroundColor: "#f4f7f9",
  }}
>
    {/* ================= SIDEBAR ================= */}
<aside
style={{
  width: isMobile ? "100%" : "250px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  padding: isMobile ? "4px 6px" : "20px",
  height: isMobile ? "auto" : "100vh",   // ✅ FULL HEIGHT LOCK
  overflowY: isMobile ? "visible" : "auto",
  textAlign: "center",
}}
>
      <img
        src={logo}
        alt="Client Exchange"
        style={{ width: "140px", margin: "0 auto 25px" }}
      />

      <Link to="/">
        <button style={buttonStyle}>Home</button>
      </Link>


      {/* ❌ Swap intentionally omitted for Cleaning */}

      {/* FILTERS */}
      <div style={{ marginTop: "20px", textAlign: "left" }}>

      
<label style={{ fontWeight: "bold" }}>View:</label>
<select
  value={filters.mode}
  onChange={(e) => {
    const mode = e.target.value;
    const service = filters.service;

    setFilters({ ...filters, mode });

    navigate(ROUTES[service][mode]);
  }}
  style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
>
  <option value="listings">Listings</option>
  <option value="swaps">Swaps</option>
  <option value="rounds">Rounds</option>
</select>

<label style={{ fontWeight: "bold" }}>Category:</label>
<select
  value={filters.service}
  onChange={(e) => {
    const service = e.target.value;
    const mode = filters.mode;

    setFilters({ ...filters, service });

    navigate(ROUTES[service][mode]);
  }}
  style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
>
  <option value="Cleaning">Cleaning</option>
  <option value="Lawn Mowing">Lawn Mowing</option>
  <option value="Pool Care">Pool Care</option>
</select>

      

        <label style={{ fontWeight: "bold" }}>State:</label>
        <select
          value={filters.state}
          onChange={(e) =>
            setFilters({ ...filters, state: e.target.value })
          }
        style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
        >
          <option value="">All</option>
          {options.state.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        <label style={{ fontWeight: "bold" }}>Postcode:</label>
        <input
          type="text"
          value={filters.postcode}
          onChange={(e) =>
            setFilters({ ...filters, postcode: e.target.value })
          }
          placeholder="Enter Postcode"
          style={{
  ...inputStyle,
  padding: isMobile ? "6px" : "10px",
  marginBottom: isMobile ? "6px" : "12px",
  fontSize: isMobile ? "0.9rem" : "1rem",
}}
        />

        <button
          onClick={() =>
            setFilters({
  service: "Cleaning",
  mode: "listings",
  state: "",
  postcode: "",
})

          }
          style={{
            ...buttonStyle,
            backgroundColor: "#d32f2f",
            marginTop: "10px",
          }}
        >
          <FaSyncAlt /> Reset Filters
        </button>
      </div>
    </aside>


      {/* ================= MAIN ================= */}

      

      
     <main
style={{
  flex: 1,
  padding: isMobile ? "12px" : "25px",
  overflowY: "auto",        // ✅ SCROLL CONTENT ONLY
  height: isMobile ? "auto" : "100vh",
}}
>
  <h2 style={{ color: "#2e7d32", marginBottom: "20px" }}>
    Cleaning Client Listings —{" "}
    <span style={{ color: "#333", fontWeight: "normal" }}>
      {filteredListings.length} Results
    </span>
  </h2>

  <div
  style={{
    textAlign: "center",
    background: "#eef8f0",
    border: "1px solid #cfe8d3",
    borderRadius: "12px",
    padding: "14px 18px",
    margin: "0 auto 20px",
    maxWidth: "700px",
    color: "#1b5e20",
    fontWeight: "700",
  }}
>
  🚀 Soft Launch: Be among the first contractors to list on Client Exchange.
</div>

        {filteredListings.length === 0 ? (
          <p>No listings found.</p>
        ) : (
          <div style={grid}>
            {filteredListings.map((l) => (
              <div key={l.listingId} style={card}>
                {/* STATUS BADGE */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    backgroundColor:
      l.listing_status === "locked" ? "#f9a825" : "#2e7d32",
    color: "#fff",
                    padding: "4px 10px",
                    borderRadius: "6px",
                    fontSize: "0.8rem",
                    fontWeight: "bold",
                  }}
                >
                  {l.listing_status === "locked" && "Buy in Progress"}
                  {l.listing_status === "active" && "Available"}
                  {l.listing_status === "sold" && "Sold"}
                </div>

   <img
  src={getImageSrc(l.image || l.image_url || l.photo)}
  alt="Cleaning"
  style={cardImage}
/>
             <div style={{ padding: "16px 18px 14px" }}>

  {/* TITLE */}
  <h3 style={{ fontWeight: "700", marginBottom: "6px", fontSize: "1.1rem" }}>
    Cleaning
  </h3>

  

  {/* LOCATION */}
  <p style={{ margin: "0 0 12px 0", color: "#666", fontSize: "0.9rem" }}>
    {l.suburb}, {l.state} {l.postcode}
  </p>
 {Number(l.licence_verified) === 1 && (
  <div style={verifiedBadge}>
    ✔ Verified Seller
  </div>
)}

  {/* Row 1: Sale Price + Avg Job Price */}
<div style={twoColRow}>
  <div style={inlineItemLeft}>
    <span style={label}>Sale Price:</span>
    <span style={valueGreen}>${Number(l.salePrice || 0).toFixed(2)}</span>
  </div>

  <div style={inlineItemRight}>
    <span style={label}>Avg Job Price:</span>
    <span style={valueGreen}>
      ${Number(l.avgJobPrice ?? l.averageJobPrice ?? l.jobPrice ?? 0).toFixed(2)}
    </span>
  </div>
</div>

{/* Row 2: Suburb + Postcode */}
<div style={twoColRow}>
  <div style={inlineItemLeft}>
    <span style={label}>📍 Suburb:</span>
    <span style={valueDark}>{l.suburb || "-"}</span>
  </div>

  <div style={inlineItemRight}>
    <span style={label}>Postcode:</span>
    <span style={valueDark}>{l.postcode || "-"}</span>
  </div>
</div>

{/* Row 3: Time + Frequency */}
<div style={twoColRow}>
  <div style={inlineItemLeft}>
    <span style={valueDark}>🕒 {Number(l.cleaningTime || 0)} hrs</span>
  </div>

  <div style={inlineItemRight}>
    <span style={valueDark}>📅 {l.frequency || "-"}</span>
  </div>
</div>

{/* BUTTON */}
<Link to={`/cleaning/listing/${l.listingId}`} style={viewBtn}>
  View Details
</Link>

{/* SMALL ID */}
<p style={{ fontSize: "0.75rem", color: "#2c2727", marginTop: "10px" }}>
  ID: {l.listingId}
</p>


</div>
              
              </div>
            ))}
          </div>
        )}
      </main>
      

    </div>
  );
}



/* ================= STYLES ================= */

const buttonStyle = {
  width: "100%",
  padding: "12px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  justifyContent: "center",
  marginBottom: "10px",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  marginBottom: "12px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: "24px",
  width: "100%",
};
const card = {
  position: "relative",
  background: "#fff",
  borderRadius: "12px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const cardImage = {
  width: "100%",
  height: "180px",
  objectFit: "cover",
};

const priceRow = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "10px",
};

const viewBtn = {
  display: "block",
  marginTop: "15px",
  textAlign: "center",
  padding: "10px",
  background: "#2e7d32",
  color: "#fff",
  borderRadius: "6px",
  textDecoration: "none",
  fontWeight: "bold",
};

const statsRow = {
  display: "flex",
  gap: "20px",
  marginBottom: "16px",
  fontSize: "0.9rem",
  color: "#444",
};

const statItem = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
};

const priceContainer = {
  fontSize: "1.4rem",
  fontWeight: "800",
  color: "#2e7d32",
  marginBottom: "14px",
};

const verifiedBadge = {
  color: "#2e7d32",
  fontWeight: "600",
  fontSize: "0.85rem",
  marginBottom: "10px",
};

const twoColRow = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  marginTop: "12px",
  alignItems: "center",
};

const inlineItemLeft = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  gap: "6px",
  minWidth: 0,
  flexWrap: "wrap",
};

const inlineItemRight = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "6px",
  minWidth: 0,
  flexWrap: "wrap",
};

const label = {
  fontSize: "0.82rem",
  fontWeight: "800",
  color: "#2e7d32",
  lineHeight: 1.1,
  whiteSpace: "nowrap",
};

const valueGreen = {
  fontSize: "0.95rem",
  fontWeight: "800",
  color: "#2e7d32",
  whiteSpace: "nowrap",
};

const valueDark = {
  fontSize: "0.95rem",
  fontWeight: "800",
  color: "#111",
  whiteSpace: "nowrap",
};
export default CleaningListings;
